<template>
    <div>
        <spinner v-if="!isHaveData"></spinner>
        <div v-if="isHaveData">
            <place v-if="places.length > 0" v-for="place in places" :item="place" :key="place.id"
                   @saved="fetchData()" class="-mb-4"></place>
            <events-list-none :subject="'Заведений нет'" v-if="!places.length" @create="addPlace"></events-list-none>
            <div v-if="places.length" class="cursor-pointer flex flex-row pt-6 w-64 h-16 items-center" @click="addPlace">
                <button class="hover-up outline-none rounded-full flex  justify-center
                items-center h-8 w-8   bg-brand-light">
                    <font-awesome-icon class="text-white text-xl"
                                       :icon="['fal', 'plus']">
                    </font-awesome-icon>
                </button>
                <div class="text-sm text-additional-text font-bold ml-4">Добавить заведение</div>
            </div>
        </div>
    </div>
</template>

<script>
import client from '@/clients/partners';
import Place from './place.vue';
import EventsListNone from '../events/calendar/none';

export default {
  name: 'Places',
  components: { EventsListNone, Place },
  data() {
    return {
      places: {},
      isHaveData: false,
    };
  },
  created() {
    this.fetchData();
  },
  methods: {
    fetchData() {
      this.isHaveData = false;
      this.places = [];
      client.get('/places')
        .then(({ data: { data: places } }) => {
          this.places = places;
          this.isHaveData = true;
        });
    },
    addPlace() {
      this.places.push({
        name: '',
        table_types: [],
        address: '',
      });
    },
  },
};
</script>

<style scoped>
    .width {
        width: 45% !important;
    }

    .selectbox-width {
        width: 16rem !important;
    }

    @media (min-width: 1200px) and (max-width: 1700px) {
        .width {
            width: 65% !important;
        }
    }
</style>
